import Link from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';
import NGText from 'src/styles/theme/components/NGText';
import { ETextOrLink } from './ParagraphWithInternalLinks.enum';
import { StyledSpan } from './ParagraphWithInternalLinks.styles';
import { IParagraphWithInternalLinks, ITextOrLink } from './ParagraphWithInternalLinks.type';

const ParagraphWithInternalLinks: FC<IParagraphWithInternalLinks> = ({
	data,
	isFirst,
	paddingTop,
	paddingBottom,
	paddingRight,
	paddingLeft,
	size,
	color
}) => {
	const router = useRouter();

	const renderContent = ({ type, value, href }: Partial<ITextOrLink>) => {
		switch (type) {
			case ETextOrLink.text:
				return value;
			case ETextOrLink.link:
				return (
					<Link href={href || '/'}>
						<a className='richtext rt-link'>{value}</a>
					</Link>
				);
			case ETextOrLink.externalLink:
				return (
					<Link href={href || '/'}>
						<a className='richtext rt-link word-wrap-anywhere' target='_blank' rel='noopener noreferrer'>
							{value}
						</a>
					</Link>
				);
			case ETextOrLink.goBack:
				return (
					<a className='richtext rt-link' onClick={router.back}>
						{value}
					</a>
				);
			default:
				return null;
		}
	};

	return (
		<NGText
			className='richtext'
			paddingTop={isFirst ? undefined : paddingTop}
			paddingBottom={paddingBottom}
			paddingRight={paddingRight}
			paddingLeft={paddingLeft}
			size={size}
			textColor={color}
		>
			{data.map(({ id, type, value, href }) => (
				<StyledSpan key={id}>{renderContent({ type, value, href })}</StyledSpan>
			))}
		</NGText>
	);
};

export { ParagraphWithInternalLinks };
